import { Type } from './type';

export const userURLs = {
  registrationAccountRoute: (t: Type) =>
    `/registration/account/${t === Type.Demo ? 'demo' : 'real'}`,
  // user base path
  base: (userId: number) => `/v1/users/${userId}`,
  // get user data
  fetch: (userId: number, withExtras: boolean) => `/v4/users/${userId}?withExtras=` + (withExtras ? 1 : 0),
  mockFetch: (userId: number, withExtras: boolean) => '/assets/mocks/user.json',
  // last user deposits
  lastDeposits: (userId: number) => `/v1/users/${userId}/latest-deposits`,
  // endpoint below will be changed in the future (to meet user service), so let it live here
  countryChangeAvailability: (country: string) => `/2/v1/promo/can-change-country?country=${country}`,
};
